<div class="address-details-container">
  <div class="row">
    <div class="col-lg-7">
      <!-- delivery address -->
      <lidl-lib-address-fe-details id="deliveryAddress" src="assets/lidl-lib-address-fe/times-light/times-light.svg"
        [title]="('modeso_address_compact-address_delivery-address' | injectedText | async)" (inputsValid)='setDeliveryValidation($event)' (inputsData)='setDeliveryData($event)'
        (alertMsg)='setAlertMsg($event)' [address]="deliveryAddress$" [isBillingAddress]="false">
      </lidl-lib-address-fe-details>
      <!-- checkbox -->
      <label class="checkbox-container">
        <input id="setBillingaddress" type="checkbox" [(ngModel)]="marked" (change)="showbillingAddress($event)">
        {{ "modeso_address_address_delivery-billing" | injectedText | async }}<span>{{ "modeso_address_address_same-address" | injectedText | async }}</span>
      </label>
      <!-- billing address -->
      <lidl-lib-address-fe-details id="billingAddress" src="assets/lidl-lib-address-fe/times-light/times-light.svg"
        [title]="('modeso_address_compact-address_billing-address' | injectedText | async)" (inputsValid)='setBillingValidation($event)' (inputsData)='setBillingData($event)'
        (alertMsg)='setAlertMsg($event)' *ngIf="!marked" [address]="billingAddress$" [isBillingAddress]="true">


      </lidl-lib-address-fe-details>
    </div>
    <div class="col-lg-5">
      <!-- cart details -->
      <div class="order-details-container">
        <ng-content></ng-content>
      </div>
      <!-- validation message -->
      <div id="alertMsg" class="validation-msg" *ngIf="alertMsgStatus()">
        <span>{{ "modeso_address_address_required-msg" | injectedText | async }}</span>
      </div>

    </div>
  </div>
</div>
